/*
  ============================================================================
  WWF-CUSTOM FILE | CL-009 | Added 2026-10-16 | Wild + Well-Fed rebrand
  CL-055 (2026-10-17): free shipping bar says the subscription qualifies.
  ----------------------------------------------------------------------------
  assets/wwf-cart-banners.js
  Keeps the cart shipping banners (snippets/wwf-cart-shipping-banners.liquid)
  correct when the cart changes without a page reload.

  Why this is needed: Palo Alto's cart drawer is built once from a template and
  then patched by the theme's own script after each change, so Liquid alone
  would leave the banners showing the state from when the page first loaded.

  How it works:
    1. Listens for Palo Alto's cart events: "theme:cart:added" (fired after
       every add, quantity change or removal) and "theme:cart:loaded" (fired
       when the drawer is rebuilt). Also refreshes after theme editor reloads
       and when a page is restored from the browser's back/forward cache.
    2. Reads the current cart from /cart.js and applies the same rules as the
       Liquid snippet (subscription minimum vs. first order offer).
    3. Handles the "Unlock free shipping" button: opens the Klaviyo form whose
       ID is set on the block (requires the Klaviyo app embed, which is on).

  Loaded by snippets/wwf-head.liquid with "defer".
  ============================================================================
*/
(function () {
  'use strict';

  /* Load guard: only run once even if the script is included twice. */
  if (window.wwfCartBanners) return;
  window.wwfCartBanners = true;

  var SELECTOR = '[data-wwf-ship-banners]';

  /* WWF-CUSTOM CL-055: shown in the free shipping bar (in place of "Spend $X
     more...") when the cart's subscription items total the subscription
     minimum or more. Edit the wording here. */
  var SUB_QUALIFIED_TEXT = 'Your subscription qualifies for free shipping.';

  /* Format an amount in cents as currency, e.g. 3000 -> "$30.00". */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Apply the banner rules to every banner block on the page. */
  function apply(cart) {
    var subscriptionTotal = 0;
    cart.items.forEach(function (item) {
      if (item.selling_plan_allocation) {
        subscriptionTotal += item.final_line_price;
      }
    });

    /* WWF-CUSTOM START | CL-055 | 2026-10-17 | Subscription-aware free shipping bar (OPEN-071) */
    var firstRoot = document.querySelector(SELECTOR);
    var subMinimum = firstRoot ? (parseInt(firstRoot.getAttribute('data-minimum'), 10) || 0) : 0;
    var subQualifies = subscriptionTotal > 0 && subMinimum > 0 && subscriptionTotal >= subMinimum;
    document.querySelectorAll('.cart-message[data-limit]').forEach(function (bar) {
      if (bar.closest('[class*="announcement"]')) return;
      var note = bar.querySelector('.wwf-sub-qualified-msg');
      if (subQualifies) {
        if (!note) {
          note = document.createElement('span');
          note.className = 'wwf-sub-qualified-msg';
          note.textContent = SUB_QUALIFIED_TEXT;
          bar.insertBefore(note, bar.firstChild);
        }
        bar.classList.add('wwf-sub-qualified');
      } else {
        bar.classList.remove('wwf-sub-qualified');
        if (note) note.remove();
      }
    });
    /* WWF-CUSTOM END | CL-055 */

    document.querySelectorAll(SELECTOR).forEach(function (root) {
      var minimum = parseInt(root.getAttribute('data-minimum'), 10) || 0;

      /* Same decision as the Liquid snippet. */
      var state = 'none';
      if (cart.item_count > 0) {
        if (subscriptionTotal > 0 && subscriptionTotal < minimum) {
          state = 'subscription';
        } else if (subscriptionTotal === 0) {
          state = 'first-order';
        }
      }

      root.hidden = state === 'none';
      root.querySelectorAll('[data-wwf-banner]').forEach(function (banner) {
        banner.hidden = banner.getAttribute('data-wwf-banner') !== state;
      });

      /* Rewrite the subscription message with the current amounts. */
      if (state === 'subscription') {
        var message = root.querySelector('[data-wwf-sub-message]');
        var template = root.getAttribute('data-sub-template') || '';
        if (message && template) {
          message.textContent = template
            .split('||minimum||').join(formatMoney(minimum, cart.currency))
            .split('||amount||').join(formatMoney(minimum - subscriptionTotal, cart.currency));
        }
      }
    });
  }

  /* Fetch the cart (debounced, so several events in a row cause one request). */
  var timer = null;
  function refresh() {
    if (!document.querySelector(SELECTOR)) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(apply)
        .catch(function () { /* Leave the banners as they are if the cart can't be read. */ });
    }, 150);
  }

  /* Palo Alto cart events (plus common names, harmless if never fired). */
  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:change', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, refresh);
    window.addEventListener(name, refresh);
  });
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  /* WWF-CUSTOM CL-055: also check once on page load (cart page and drawer). */
  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);

  /* "Unlock free shipping" button: open the Klaviyo form set on the block. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wwf-klaviyo-open]');
    if (!button) return;
    var root = button.closest(SELECTOR);
    var formId = root ? root.getAttribute('data-klaviyo-form') : '';
    if (!formId) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
})();
